import { render } from "./SignUpModal.vue?vue&type=template&id=44c67288"
import script from "./SignUpModal.vue?vue&type=script&lang=js"
export * from "./SignUpModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__